export const enum RewardTypeFieldNamesEnum {
  TYPE = 'type',
  REWARD_TYPE = 'rewardType',
}
